import { FC } from 'react';
import serverVars from 'server-vars';

import { ModalContainer } from 'dibs-elements/exports/ModalContainer';
import { BarHeader } from 'dibs-elements/exports/BarHeader';
import { ModalBody } from 'dibs-elements/exports/ModalBody';
import { ModalCloseButton } from 'dibs-elements/exports/ModalCloseButton';

import styles from './styles/SendFeedbackModal.scss';
import { FormattedMessage } from 'dibs-react-intl';

type SendFeedbackModalProps = {
    isOpen: boolean;
    onClose: () => void;
};

export const SendFeedbackModal: FC<SendFeedbackModalProps> = ({ isOpen, onClose }) => {
    const sellerId = serverVars.get('sellerData.id');
    const pageType = serverVars.get('tracking.pageType');
    const params = new URLSearchParams({
        sellerId,
        pageType,
    });

    return (
        <ModalContainer
            isOpen={isOpen}
            dataTn="send-feedback-modal"
            onClose={onClose}
            modalPosition="center"
        >
            <ModalCloseButton onClick={onClose} />
            <BarHeader
                title={
                    <FormattedMessage
                        id="dal.SendFeedbackModal.sendFeedback"
                        defaultMessage="Send Feedback"
                    />
                }
            />
            <ModalBody>
                <iframe
                    className={styles.sendFeedbackIframe}
                    src={`https://1stdibs.getfeedback.com/e/LjkJ0DU2?gf_footer_background_off&gf_hide_progress&${params.toString()}`}
                    // Can't be added to class as it's Iframe and used for loading skeleton
                    style={{ backgroundColor: '#E3E3E3' }}
                />
            </ModalBody>
        </ModalContainer>
    );
};
